import React from 'react'

import { Body1, Box, Join, Space } from '@gousto-internal/citrus-react'

import type { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { LoadingSkeleton } from '../LoadingSkeleton'

type RecipeDescriptionProps = {
  description?: MenuRecipe['description']
  packagingDescriptionHTML?: string | null
  loading: boolean
}

export const RecipeDescription = ({
  description,
  packagingDescriptionHTML,
  loading,
}: RecipeDescriptionProps) => (
  <Join with={<Space size={2} />}>
    <Box data-testing="recipeDetailsDescription" paddingV={3}>
      {loading ? (
        <LoadingSkeleton style={{ height: '125px', width: '95%' }} />
      ) : (
        <>
          <Body1 data-testid="recipeDetailsDescriptionBody">{description}</Body1>
          {packagingDescriptionHTML && (
            <Body1
              style={{ paddingTop: '0.5rem' }}
              data-testid="recipeDetailsPackingDescriptionBody"
              dangerouslySetInnerHTML={{ __html: packagingDescriptionHTML }}
            />
          )}
        </>
      )}
    </Box>
  </Join>
)
